const filter = {
    namespaced: true,
    state: {
        // 学段
        stageList:[],
        // 年纪
        gradeList:[],
        // 学期
        termList:[],
        // 学科
        subjectList:[],
        // 版本
        publisherList:[],
        // 教材
        textBookList:[],
        // 难易度
        difficultyList:[],
        // 课程类型
        courseTypeList:[],
    },
    getters: {

    },
    mutations: {
        setStageList(state,value){
            state.stageList = value;
        },
        setGradeList(state,value){
            state.gradeList = value;
        },
        setTermList(state,value){
            state.termList = value;
        },
        setSubjectList(state,value){
            state.subjectList = value;
        },
        setPublisherList(state,value){
            state.publisherList = value;
        },
        setTextBookList(state,value){
            state.textBookList = value;
        },
        setDifficultyList(state,value){
            state.difficultyList = value;
        },
        setCourseTypeList(state,value){
            state.courseTypeList = value;
        }
    },
    actions: {
    }
}
export default filter